module.exports = __webpack_public_path__ + "static/media/exit-icon.c1adcf7c.svg";